import { useMutation } from '@tanstack/react-query'

import { usersPasswordResetPost } from '@src/api'
import { DefaultApiUsersPasswordResetPostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUsersPasswordResetPost = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUsersPasswordResetPostRequest) =>
      usersPasswordResetPost(axiosInstance, params),
  })
}
